import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class UserFilter {
  public search: string = ''
  public tenantId: string | null = null
  public excluded: string[] = []
  public roles: string[] = []
  public paging: PaginationRequest = new PaginationRequest()
}
